import { apiConnector } from "../apiconnector";
import toast from "react-hot-toast";
import { worksheetEndpoints } from "../apis";


export const getAISuggestion = async (guideWord, parameter) => {
  let result = null;
  try {
    const response = await apiConnector(
      "POST",
      worksheetEndpoints.GET_AI_SUGGESTIONS_API, // This will be your backend endpoint
      { guideWord, parameter },
    );

    if (!response.success) {
      throw new Error(response.data.message);
    }

    result = response.data; // Assuming your backend sends the AI data in response.data.data
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to fetch AI suggestions");
    throw error; 
  }
  return result;
};

// Create a worksheet
export const createWorksheet = async (data) => {
  try {
    const response = await apiConnector(
      "POST",
      worksheetEndpoints.CREATE_WORKSHEET_API,
      data,
    );
    toast.success("Worksheet created successfully!");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to create worksheet");
    throw err;
  }
};

// Get worksheets by node
export const getWorksheetsByNode = async (nodeId) => {
  try {
    const response = await apiConnector(
      "GET",
      worksheetEndpoints.GET_WORKSHEETS_BY_NODE_API(nodeId),
      null,
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch worksheets");
    throw err;
  }
};


// Get a single worksheet by its ID
export const getSingleWorksheet = async (worksheetId) => {
  try {
    const response = await apiConnector(
      "GET",
      worksheetEndpoints.GET_SINGLE_WORKSHEET_API(worksheetId),
      null,
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch worksheet");
    throw err;
  }
};

// Delete a worksheet by its ID
export const deleteWorksheet = async (worksheetId) => {
  try {
    const response = await apiConnector(
      "DELETE",
      worksheetEndpoints.DELETE_WORKSHEET_API(worksheetId),
      null,
    );
    toast.success("Worksheet deleted");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to delete worksheet");
    throw err;
  }
};


export const getAISuggestions = async (guideWord, parameter) => {
  try {
    const response = await apiConnector(
      "POST",
      worksheetEndpoints.GET_SUGGESTIONS,
      { guideWord, parameter },
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch AI suggestions");
    throw err;
  }
};


// Get all worksheets for a node (admin view)
export const getAdminNodeWorksheets = async (nodeId) => {
  try {
    const response = await apiConnector(
      "GET",
      worksheetEndpoints.GET_ADMIN_NODE_WORKSHEETS_API(nodeId),
      null,
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch admin worksheets");
    throw err;
  }
};

// Update Worksheet Entry by Entry ID
export const updateWorksheet = async (entryId, data) => {
  try {
    const response = await apiConnector("PUT",
      worksheetEndpoints.UPDATE_WORKSHEET_API(entryId),
      data,
    );
    return response;
  } catch (error) {
    console.error("Error updating worksheet :", error);
    toast.error(error.response?.data?.message || "Error updating worksheet");
    throw error;
  }
};

